<template>
  <div class="row form-row">
    <div class="col-sm-4 mb-2">
      <auto-complete
        :key="`${yearOptions}`"
        rules="required"
        :label="$t('message.trade.vehicleInfo.year')"
        :placeholder="$t('message.trade.vehicleInfo.selectYear')"
        :disabled="yearOptionsFiltered.length === 0 || disableSelectorValues"
        :hiddenLabel="false"
        v-model="year"
        :sourceData="yearOptionsFiltered"
        @selectedValue="updateMake"
        id="yearId"
        vid="yearId"
        data-cy="year"
      >
      </auto-complete>
    </div>
    <div class="col-sm-8 mb-2">
      <auto-complete
        :key="`${makeOptions}`"
        rules="required"
        :label="$t('message.trade.vehicleInfo.make')"
        :placeholder="$t('message.trade.vehicleInfo.selectMake')"
        :disabled="makeOptions.length === 0 || disableSelectorValues"
        :hiddenLabel="false"
        v-model="make"
        :sourceData="makeOptions"
        @selectedValue="updateModel"
        id="makeId"
        vid="makeId"
        data-cy="make"
      >
      </auto-complete>
    </div>
    <div class="col-12 mb-2">
      <auto-complete
        :key="`${modelOptions}`"
        rules="required"
        :label="$t('message.trade.vehicleInfo.model')"
        :placeholder="$t('message.trade.vehicleInfo.selectModel')"
        :disabled="modelOptions.length === 0 || disableSelectorValues"
        :hiddenLabel="false"
        v-model="model"
        :sourceData="modelOptions"
        id="modelId"
        vid="modelId"
        data-cy="model"
      >
      </auto-complete>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import log from '@/services/log';
import AutoComplete from '@/components/shared/AutoComplete.vue';

export default {
  components: { AutoComplete },
  computed: {
    ...mapGetters({
      yearOptions: 'trade/getYearOptions',
      makeOptions: 'trade/getMakeOptions',
      modelOptions: 'trade/getModelOptions',
    }),
    yearOptionsFiltered() {
      return this.yearOptions.map(year => String(year));
    },
    year: {
      get() {
        return this.$store.state.trade.vehicle.year;
      },
      set(value) {
        if (value !== this.$store.state.trade.vehicle.year) {
          this.$store.commit('trade/SET_VEHICLE_YEAR', value);
          this.resetOptions(['make', 'model']);
        }
      },
    },
    make: {
      get() {
        return this.$store.state.trade.vehicle.make;
      },
      set(value) {
        if (value !== this.$store.state.trade.vehicle.make) {
          this.$store.commit('trade/SET_VEHICLE_MAKE', value);
          this.resetOptions(['model', 'trim']);
        }
      },
    },
    model: {
      get() {
        return this.$store.state.trade.vehicle.model;
      },
      set(value) {
        if (value !== this.$store.state.trade.vehicle.model) {
          this.$store.commit('trade/SET_VEHICLE_MODEL', value);
          this.resetOptions(['trim', 'engine']);
        }
      },
    },
  },
  props: {
    disableSelectorValues: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    try {
      await this['trade/getYears']();
      if (
        this.$store.state.trade.vehicle &&
        this.$store.state.trade.vehicle.year !== '' &&
        this.$store.state.trade.vehicle.make !== '' &&
        this.$store.state.trade.vehicle.model !== ''
      ) {
        await this['trade/getMakes']();
        await this['trade/getModels']();
      }
    } catch (error) {
      log('Error in Selection Year', error);
      this.$router.push({ path: `${this.getProductBasePath()}/error` });
    }
  },
  methods: {
    ...mapActions(['trade/getYears', 'trade/getMakes', 'trade/getModels', 'trade/resetVehicleOptions']),
    async updateMake(event) {
      if (event && event.detail && event.detail.selection) {
        this.year = event.detail.selection.value;
        if (!this.year) {
          return;
        }
        try {
          await this['trade/getMakes']();
        } catch (error) {
          this.$store.commit('SET_LOADING', false);
          log('Error in Selection Make', error);
          this.$router.push({ path: `${this.getProductBasePath()}/error` });
        }
      }
    },
    async updateModel(event) {
      if (event && event.detail && event.detail.selection) {
        this.make = event.detail.selection.value;
        if (!this.make) {
          return;
        }
        try {
          await this['trade/getModels']();
        } catch (error) {
          this.$store.commit('SET_LOADING', false);
          log('Error in Selection Model', error);
          this.$router.push({ path: `${this.getProductBasePath()}/error` });
        }
      }
    },
    resetOptions(options) {
      this['trade/resetVehicleOptions'](options);
    },
  },
};
</script>
